import { render, staticRenderFns } from "./RecordAudio.vue?vue&type=template&id=2d7a98c8&scoped=true"
import script from "./RecordAudio.vue?vue&type=script&lang=js"
export * from "./RecordAudio.vue?vue&type=script&lang=js"
import style0 from "./RecordAudio.vue?vue&type=style&index=0&id=2d7a98c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a98c8",
  null
  
)

export default component.exports